// Emits the per-page, per-locale <head>: title, description, canonical, the
// hreflang cluster (what tells each country's Google "here's the version in
// your language"), and basic Open Graph tags. Drop one <LocalizedMeta> at the
// top of each landing page.
import { Helmet } from 'react-helmet-async';
import { SUPPORTED_LNGS, DEFAULT_LNG } from './index';

const ORIGIN = 'https://rush-studio.com'; // prod origin

// path = the page path WITHOUT locale prefix, e.g. '/pricing' or '/'.
export default function LocalizedMeta({ path, title, description, lang }) {
  const clean = path === '/' ? '' : path;
  const urlFor = (lng) =>
    lng === DEFAULT_LNG ? `${ORIGIN}${clean || '/'}` : `${ORIGIN}/${lng}${clean}`;
  const canonical = urlFor(SUPPORTED_LNGS.includes(lang) ? lang : DEFAULT_LNG);

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {SUPPORTED_LNGS.map((lng) => (
        <link key={lng} rel="alternate" hrefLang={lng} href={urlFor(lng)} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={urlFor(DEFAULT_LNG)} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
    </Helmet>
  );
}
